// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 196) return "static/css/196.b885b5076.chunk.css";
	// return url for filenames based on template
	return undefined;
};